import { ICommessa } from "./../interfaces/ICommessa";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Loading } from "../utils/loading";
import { GestioneAllegatiService } from "../services/gestione-allegati.service";
import { finalize } from "rxjs/operators";
import { AlertUtil } from "../utils/alert-util";
import { DynamicDialogRef } from "primeng/api";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RequestBuilder } from "../classes/request-builder";
import { CommessaService } from "../services/commessa.service";

@Component({
  selector: "app-gestione-allegati-modal",
  templateUrl: "./gestione-allegati-modal.component.html",
  styleUrls: ["./gestione-allegati-modal.component.css"],
})
export class GestioneAllegatiModalComponent implements OnInit {
  uploadedFiles: any[] = []; //for upload file
  nameAllegato: string = null; //name allegato
  payloadSaveAllegato: any;
  allegatiForm: FormGroup;

  commesse: ICommessa[];
  selectedCommessa: ICommessa;

  constructor(
    private gestioneAllegatiService: GestioneAllegatiService,
    private alertUtil: AlertUtil,
    public ref: DynamicDialogRef,
    private formBuilder: FormBuilder,
    private commessaService: CommessaService,
    private cdRef: ChangeDetectorRef
  ) {
    //build form group
    this.allegatiForm = this.formBuilder.group({
      commesse: ["", Validators.required],
      descrizioneAllegato: [""],
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.getAllCommesse();
    }, 0);
  }

  // convenience getter for easy access to form fields
  get form() {
    return this.allegatiForm.controls;
  }

  /**
   * click button allega doc
   * @param event file
   * @param question question selected
   */
  uploadClick(event: any, upload: any) {
    this.uploadedFiles = [];
    upload.clear();
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.nameAllegato = this.uploadedFiles[0].name;
    this.cdRef.detectChanges();
  }

  /**
   * save invio allegato method
   */
  saveInvioAllegato() {
    this.payloadSaveAllegato = {
      descrizioneAllegato:
        this.allegatiForm.controls["descrizioneAllegato"].value,
      commessa: this.allegatiForm.controls["commesse"].value,
    };
    this.callSaveAllegato(this.payloadSaveAllegato);
  }

  /**
   * call service for save allegato
   * // Modifica del 11/11/2024 - Gestita la multicommessa
   */
  callSaveAllegato(object: any) {
    Loading.isLoading = true;
    this.gestioneAllegatiService
      .uploadAllegato(
        this.uploadedFiles[0],
        this.uploadedFiles[0].name,
        object.descrizioneAllegato,
        this.formatCommessa(object.commessa)
      )
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe((response) => {
        if (response.data) {
          //return all allegatoObj
          this.invioAllegatoSuccesMessage();
        } else {
          this.alertUtil.showErrorAlert("LBL_ERROR_300");
        }
      });
  }

  /**
   * invio success
   */
  invioAllegatoSuccesMessage() {
    this.alertUtil.showAlert(
      "LBL_ALLEGATO_SEND_SUCCESS",
      null,
      null,
      null,
      () => {
        this.ref.close(true);
      }
    );
  }

  /**
   * dropdown commessa clicked
   */
  onCommessaClicked() {
    this.selectedCommessa = this.allegatiForm.controls["commesse"].value;
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true;
    let reqBuilder = new RequestBuilder({});
    this.commessaService
      .getAllCommesseAllegati(reqBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            this.commesse = response.data;
          } else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log("ERROR: " + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", {
              error: response.Message,
            });
          }
        },
        (error) => {
          let errorKey = "LBL_HTTP_ERROR_0";
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * Modifica del 11/11/2024 - Aggiunto metodo che formatta la commessa
   * @param commessa
   * @returns
   */
  private formatCommessa(commessa: any): string {
    let order: string = "";
    if (commessa.length > 0) {
      commessa.forEach((c) => {
        order += `${c.Id},`;
      });
    }
    return order.substring(0, order.length - 1);
  }
}
